import {
    IStyle,
    IButtonStyles,
    ITooltipStyles,
    ICheckboxStyles,
    IDetailsRowProps,
    ITextFieldStyles,
    IDetailsRowStyles,
    IDetailsListStyles,
    IDetailsHeaderStyles
} from "@fluentui/react";
import { IColumn } from "@fluentui/react/lib/DetailsList";
import { toast } from "react-toastify";
import { reco_type_choices, tooltipContentGroup } from "./interfaces";

// fields excluded from vertical paste (paste distributed lines across rows)
export const noVerticalPasteFields = new Set<string>(["description", "other_01", "other_02", "other_03", "other_04"]);

// invoice main table (on left of invoice) - which fields will have citation button on top right
export const invItemsWithCitationLink: string[] = [
    "item_barcode",
    "item_client_code",
    "item_code",
    "description",
    "unit_price",
    "total_price",
    "invoice_total",
    "invoice_total_net",
    "vat",
    "item_code"

];

// used in invoiceitemstable
export const numFieldsOnlyNum = [
    "total_price",
    "discount",
    "quantity",
    "unit_price"
]

// used in invoiceitemstable
export const optVisFields = [
    { key: "item_client_code", name: "Client Code" },
    { key: "item_code", name: "Vendor Code" },
    { key: "item_barcode", name: "Barcode" },
    { key: "item_measure", name: "Measure" },
    { key: "item_vat", name: "Vat" },
    { key: "excise_tax", name: "Excise Tax" },
    { key: "discount", name: "Discount" },
    { key: "discount_is_perc", name: "Is %?" },
    { key: "unit_price_net_final", name: "Discounted Unit Price" },
    { key: "compound_quantity", name: "Compound Quantity" },
    { key: "other_01", name: "Info1" },
    { key: "other_02", name: "Info2" },
    { key: "other_03", name: "Info3" },
    { key: "other_04", name: "Info4" }
];

// used in invoiceitemstable
export const invPOTableColOrd: string[] = [
    "Стока",
    "Код",
    "Мярка",
    "item_number",
    "product_name",
    "invoice_desc",
    "doc_id",
    "amount",
    "doc_type",
    "quantity_received",
    "ai_recon.quantity_received",
    "ai_recon.difference_in_quantity",
    "ai_recon.ordered_item_total",
    "ai_recon.received_item_total",
    "invoice_unit_price",
    "unit_price",
    "purchase_price",
    "ai_recon.difference_in_unit_price",
    "difference_in_quantity",
    "difference_in_unit_price",
    "received_item_total",
    "ordered_item_total",
    "item_code",
    "description",
    "total_price",
    "measure",
    "reasoning_for_match",
    "total",
    "branch_name",
    "contractor_name",
    "doc_date",
    "partition",
    "branch_id",
    "supplier_name",
    "purchase_order_item_number",
    "product_code"
];

// used in invoiceitemstable
export const invItemsTableHeaderTooltips: tooltipContentGroup[] = [
    {
        title: 'Operations',
        classToUse: 'toolTipInfoLeftHorizontalLineTwo',
        items: [
            {title: 'Reorder Columns', content: 'Left Click', classToUse: 'headerTooltipInfoItem', },
            {title: 'Empty Column', content: 'Right Click', classToUse: 'headerTooltipInfoItem', },
            {title: 'Reorder columns', content: 'Drag to another header', classToUse: 'headerTooltipInfoItem', },
            {title: 'Swap column values', content: 'Ctrl + drag to another header', classToUse: 'headerTooltipInfoItem'},
            {title: 'Copy values to another column', content: 'Alt + drag to another header (overwrites target values)', classToUse: 'headerTooltipInfoItem'}
        ]
    }
];






// used in recoCellStayOnHov
export const vertMidl: string[] = [
    "unit_price"
];

// used in recoCellStayOnHov
export const vertOrdOrd: string[] = [
    "Стока",
    "Код",
    "reasoning_for_match",
    "difference_in_quantity",
    "difference_in_unit_price",
    "ordered_item_total",
    "received_item_total",
    "quantity_ordered",
    "quantity received",
    "unit_price",
    "invoice_unit_price",
    "product_name",
    "invoice_desc",
    "doc_id",
    "doc_type",
    "quantity_received",
    "purchase_price",
    "product_code",
    "received_item_total",
    "ordered_item_total",
    "item_code",
    "description",
    "measure",
    "total",
    "branch_name",
    "contractor_name",
    "doc_date",
    "partition",
    "branch_id",
    "supplier_name"

];

// used in recoCellStayOnHov
interface InvPOTableDisplayRename {
    name: string;
    width?: number;
    minWidth?: number;
    maxWidth?: number;
}

// used in datavisualizationcallout
export const invPOTableDisplayRenames = new Map<string, InvPOTableDisplayRename>([
    ["id", { "name"                                     : "ID (sys)", "width": 40, "minWidth": 40 }],
    ["product_name", {"name"                            : "Product", "width": 500, "minWidth": 100 }],
    ["doc_id", { "name"                                 : "Doc ID", "width": 220, "minWidth": 150 }],
    ["doc_type", { "name"                               : "Doc Type", "width": 200, "minWidth": 100 }],
    ["branch_id", { "name"                              : "Branch", "width": 60, "minWidth": 50 }],
    ["quantity_received", { "name"                      : "Received", "width": 80, "minWidth": 50 }],
    ["quantity_ordered", { "name"                       : "Ordered", "width": 80, "minWidth": 50 }],
    ["received_item_total", { "name"                    : "Received Cost", "width": 100, "minWidth": 50 }],
    ["ordered_item_total", { "name"                     : "Ordered Cost", "width": 100, "minWidth": 50 }],
    ["description", { "name"                            : "Inv. Desc.", "width": 300, "minWidth": 50 }],
    ["unit_price", { "name"                             : "Ord. Unit Price", "width": 60, "minWidth": 60 }],
    ["total_price", { "name"                            : "Inv. Total Price", "width": 100, "minWidth": 50 }],
    ["product_code", { "name"                           : "Item Code", "width": 40, "minWidth": 40 }],
    ["total", { "name"                                  : "Total", "width": 100, "minWidth": 50 }],
    ["amount", { "name"                                 : "Ord. Qty.", "width": 30, "minWidth": 30 }],
    ["difference_in_quantity", { "name"                 : "Qty. Diff.", "width": 100, "minWidth": 80  }],
    ["difference_in_unit_price", { "name"               : "Unit Price Diff.", "width": 100, "minWidth": 50  }],
    ["branch_name", { "name"                            : "Branch Name", "width": 100, "minWidth": 50  }],
    ["contractor_name", { "name"                        : "Contractor Name", "width": 100, "minWidth": 50  }],
    ["doc_date", { "name"                               : "Order Date", "width": 100, "minWidth": 50  }],
    ["measure", { "name"                                : "Msr.", "width": 50, "minWidth": 50  }],
    ["reasoning_for_match", { "name"                    : "Match Reason", "width": 100, "minWidth": 50  }],
    ["partition", { "name"                              : "Partition", "width": 100, "minWidth": 50  }],
    ["item_number", { "name"                            : "№", "width": 40, "minWidth": 40, "maxWidth": 30 }],
    ["purchase_order_item_number", { "name"             : "PO ID (sys)", "width": 50, "minWidth": 50 }],
    ["invoice_item_number", { "name"                    : "Inv. ID (sys)", "width": 50, "minWidth": 50 }],
    ["inv_item_num", { "name"                           : "Inv. Item No.", "width": 50, "minWidth": 50 }],
    ["purchase_order", { "name"                         : "PO", "width": 150, "minWidth": 50 }],
    ["item_description", { "name"                       : "PO Item Desc.", "width": 300, "minWidth": 50 }],
    ["item_total_price", { "name"                       : "PO Item Total", "width": 100, "minWidth": 50 }],
    ["purchase_order_id", { "name"                      : "PO ID", "width": 100, "minWidth": 50 }],
    ["customer_vat_identification", { "name"            : "Client VAT ID", "width": 150, "minWidth": 50 }],
    ["contractor_vat_identification", { "name"          : "Contractor VAT ID", "width": 150, "minWidth": 50 }],
    ["doc_total_currency", { "name"                     : "Document Currency", "width": 100, "minWidth": 50 }],
    ["idoc_created_date", { "name"                      : "Created Date", "width": 100, "minWidth": 50 }],
    ["item_measure", { "name"                           : "PO Item Msr.", "width": 80, "minWidth": 50 }],
    ["item_unit_price", { "name"                        : "PO Unit Price", "width": 100, "minWidth": 50 }],
    ["net_weight", { "name"                             : "Net Weight", "width": 100, "minWidth": 50 }],
    ["payment_due_date", { "name"                       : "Due Date", "width": 120, "minWidth": 50 }],
    ["payment_terms_days", { "name"                     : "Terms Days", "width": 120, "minWidth": 50 }],
    ["price_denominator", { "name"                      : "Denominator", "width": 100, "minWidth": 50 }],
    ["requested_delivery_date", { "name"                : "Requested Delivery", "width": 150, "minWidth": 50 }],
    ["weight_unit", { "name"                            : "Weight Unit", "width": 80, "minWidth": 50 }],
    ["price", { "name"                                  : "Price", "width": 100, "minWidth": 50 }],
    ["order_date", { "name"                             : "Ord. Date", "width": 60, "minWidth": 60 }],
    ["order_id", { "name"                               : "Ord. Id", "width": 60, "minWidth": 60 }],
    ["order_type", { "name"                             : "Ord. Type", "width": 50, "minWidth": 50 }],
    ["supplier_name", { "name"                          : "Supplier", "width": 80, "minWidth": 80 }],
    ["ai_recon.invoice_item_number", { "name"           : "Inv. Sys. ID", "width": 50, "minWidth": 50 }],
    ["ai_recon.difference_in_quantity", { "name"        : "Qty Diff.", "width": 50, "minWidth": 50 }],
    ["ai_recon.difference_in_unit_price", { "name"      : "Price Diff.", "width": 50, "minWidth": 40 }],
    ["ai_recon.ordered_item_total", { "name"            : "Ord. Total", "width": 100, "minWidth": 70 }],
    ["ai_recon.purchase_order_item_number", { "name"    : "Ord. Sys. ID", "width": 150, "minWidth": 70 }],
    ["ai_recon.quantity_ordered", { "name"              : "Ord. Qty.", "width": 100, "minWidth": 70 }],
    ["ai_recon.quantity_received", { "name"             : "Inv. Qty.", "width": 100, "minWidth": 70 }],
    ["ai_recon.reasoning_for_match", { "name"           : "Match Reason", "width": 100, "minWidth": 70 }],
    ["ai_recon.received_item_total", { "name"           : "Inv. Total", "width": 100, "minWidth": 70 }],
    ["invoice_desc", { "name"                           : "Inv. Desc.", "width": 500, "minWidth": 100 }],
    ["invoice_unit_price", { "name"                     : "Inv. Unit Price", "width": 500, "minWidth": 100 }],
    ["item_mapping_number", { "name"                    : "Mapping ID (sys)", "width": 40, "minWidth": 40 }],
]);










export const doArrPropExist = ( items: any, prop_name_01: string ) => {
    if ( !items || !Array.isArray( items ) ) return false;
    return items?.some(( item: any ) =>{
        return item?.[ prop_name_01 ] !== undefined && item?.[ prop_name_01 ];
    } );
};

export const doArrPropsEq = ( items: any, prop_name_01: string, prop_name_02: string ) =>{
    if ( !items || !Array.isArray( items ) ) return false;

    return items?.some(( item: any ) =>{
        return item?.[prop_name_01] != item?.[ prop_name_02 ] && item?.[ prop_name_02 ] !== undefined;
    });
};

export const calcDiscount = ( finalPrice: number, discountValue: number, isPerc = false ) => {
    try {
        if (isPerc == true){
            const discount = finalPrice * ( discountValue / 100 );  // if % › calc discount amount from final price
            return Math.round( discount * 100 ) / 100;              // return discount amount rounded to 2 dec
        } else {
            return Math.round( discountValue * 100 ) / 100;         // if discount is amount › return as is (+ round to 2 dec)
        }
    } catch (e) {
        return 0;
    }
}

export const copyToClipboardInvoice = ( data: any, whichTable?: number ) =>
{
    if ( !data || typeof data !== "object" ){
        toast.error( "Problem encountered with producing CSV. Please contact support." );
        return;
    }



    // separate the root object and the invoice_items array
    const { invoice_items, ...rootData } = data;


    let invoicePop = invoice_items.map(({ _p1_flags, ...rest }: any) => rest);
    invoicePop = invoicePop.map(({ _p2_flags, ...rest }: any) => rest);


    // convert a single object to CSV (one-row table)
    const convertObjectToCSV = ( obj: Record<string, any> ): string => {
        const headers = Object.keys( obj );
        const values = headers.map( field => `"${ String( obj[ field ] ).replace( /"/g, '""' ) }"` );
        return headers.join( "," ) + "\n" + values.join( "," );
    };

    // convert an array of objects to CSV (multi-row table)
    const convertArrayToCSV = ( arr: Record<string, any>[] ): string => {
        if ( !Array.isArray( arr ) || arr.length === 0 ) return "";
        const headers = Object.keys( arr[ 0 ] );
        const rows = arr.map( row => headers.map( field => `"${ String( row[ field ] ?? "" ).replace( /"/g, '""' ) }"` ).join( "," ) );
        return headers.join( "," ) + "\n" + rows.join( "\n" );
    };

    const rootCSV = convertObjectToCSV( rootData );
    const itemsCSV = convertArrayToCSV( invoicePop || [] );

    let combinedCSV = `${ rootCSV }\n\n${ itemsCSV }`;  // multiple csv tables returned

    if ( whichTable && whichTable == 1 )
    {
        combinedCSV = `${ rootCSV }`;                 // main invoice table
    } else if ( whichTable && whichTable == 2 )
    {
        combinedCSV = `${ itemsCSV }`;                 // items  table csv
    }

    navigator.clipboard
        .writeText( combinedCSV )
        .then( () =>
        {
            toast.success( "Root + invoice_items copied to Clipboard as CSV!" );
        } )
        .catch( err =>
        {
            toast.error( "Failed to copy CSV." );
            console.error( err );
        } );
};

export const invoiceItemsTableColumns = (
    renderEditableCell: ( item: any, index?: number, column?: IColumn ) => JSX.Element,
    renderDisabledCell: ( item: any, index?: number, column?: IColumn ) => JSX.Element,
    renderTogglebleCell: ( item: any, index?: number, column?: IColumn ) => JSX.Element,
    renderRecoCell: ( item: any, index?: number, column?: IColumn ) => JSX.Element,
    renderDisabledNestedCell: ( item: any, index?: number, column?: IColumn ) => JSX.Element,
    includeCompoundQuantity?: boolean,
    includeRecoData?: boolean,
    recoType?: reco_type_choices,
    recoDynamicCols?: string[],
    isThereOther1?: boolean,
    isThereOther2?: boolean,
    isThereOther3?: boolean,
    isThereOther4?: boolean
) =>
{
    let cols: IColumn[] = [
        {
            key: 'item_number',
            name: '№',
            fieldName: 'item_number',
            minWidth: 20,
            maxWidth: 30,
            currentWidth: 20,
            isResizable: true,
            isPadded: false,
            onRender: renderEditableCell
        },
        {
            key: 'item_client_code',
            name: 'Client Code',
            fieldName: 'item_client_code',
            currentWidth: 60,
            minWidth: 50,
            maxWidth: 90,
            isResizable: true,
            onRender: renderEditableCell
        },
        {
            key: 'item_code',
            name: 'Vendor Code',
            fieldName: 'item_code',
            minWidth: 60,
            maxWidth: 90,
            currentWidth: 60,
            isResizable: true,
            isPadded: false,
            onRender: renderEditableCell
        },
        {
            key: 'item_barcode',
            name: 'Barcode',
            fieldName: 'item_barcode',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            isPadded: false,
            onRender: renderEditableCell
        },
        {
            key: 'description',
            name: 'Description',
            fieldName: 'description',
            minWidth: 150,
            isResizable: true,
            isPadded: false,
            onRender: renderEditableCell
        },
        {
            key: 'discount_is_perc',
            name: 'Is %',
            fieldName: 'discount_is_perc',
            minWidth: 20,
            currentWidth: 20,
            isResizable: true,
            onRender: renderTogglebleCell
        },
        {
            key: 'discount',
            name: 'Discount',
            fieldName: 'discount',
            minWidth: 50,
            currentWidth: 60,
            isResizable: true,
            onRender: renderEditableCell
        },
        ...((includeRecoData && includeRecoData == true) ? [
            {
                key: 'reconciliation',
                name: 'Recon.',
                fieldName: 'reconciliation',
                minWidth: 30,
                currentWidth: 50,
                maxWidth: 60,
                isResizable: true,
                isPadded: false,
                onRender: renderRecoCell
            }
        ] : []),
        ...((isThereOther1 && isThereOther1 == true) ? [
            {
                key: 'other_01',
                name: 'Info1',
                fieldName: 'other_01',
                minWidth: 30,
                currentWidth: 50,
                maxWidth: 60,
                isResizable: true,
                isPadded: false,
                onRender: renderDisabledCell
            }
        ] : []),
        ...((isThereOther2 && isThereOther2 == true) ? [
            {
                key: 'other_02',
                name: 'Info2',
                fieldName: 'other_02',
                minWidth: 30,
                currentWidth: 50,
                maxWidth: 60,
                isResizable: true,
                isPadded: false,
                onRender: renderDisabledCell
            }
        ] : []),
        ...((isThereOther3 && isThereOther3 == true) ? [
            {
                key: 'other_03',
                name: 'Info3',
                fieldName: 'other_03',
                minWidth: 30,
                currentWidth: 50,
                maxWidth: 60,
                isResizable: true,
                isPadded: false,
                onRender: renderDisabledCell
            }
        ] : []),
        ...((isThereOther4 && isThereOther4 == true) ? [
            {
                key: 'other_04',
                name: 'Info4',
                fieldName: 'other_04',
                minWidth: 30,
                currentWidth: 50,
                maxWidth: 60,
                isResizable: true,
                isPadded: false,
                onRender: renderDisabledCell
            }
        ] : []),
        {
            key: 'item_type',
            name: 'Item Type',
            fieldName: 'item_type',
            minWidth: 30,
            currentWidth: 50,
            isResizable: true,
            isPadded: false,
            onRender: renderDisabledCell
        },
        {
            key: 'item_measure',
            name: 'Measure',
            fieldName: 'item_measure',
            minWidth: 30,
            currentWidth: 50,
            isResizable: true,
            isPadded: false,
            onRender: renderEditableCell
        },
        {
            key: 'quantity',
            name: 'Quantity',
            fieldName: 'quantity',
            minWidth: 30,
            currentWidth: 50,
            isResizable: true,
            isPadded: false,
            onRender: renderEditableCell
        },
        {
            key: 'unit_price',
            name: 'Unit Price',
            fieldName: 'unit_price',
            minWidth: 50,
            currentWidth: 60,
            isResizable: true,
            isPadded: false,
            onRender: renderEditableCell
        },
        {
            key: 'unit_price_net_final',
            name: 'Discounted Unit Price',
            fieldName: 'unit_price_net_final',
            minWidth: 50,
            currentWidth: 60,
            isResizable: true,
            isPadded: false,
            onRender: renderEditableCell
        },
        {
            key: 'item_vat',
            name: 'Vat',
            fieldName: 'item_vat',
            minWidth: 30,
            maxWidth: 60,
            isResizable: true,
            isPadded: false,
            onRender: renderEditableCell
        },
        {
            key: 'excise_tax',
            name: 'Excise Tax',
            fieldName: 'excise_tax',
            minWidth: 30,
            maxWidth: 60,
            isResizable: true,
            isPadded: false,
            onRender: renderEditableCell
        },
        {
            key: 'total_price',
            name: 'Line Price',
            fieldName: 'total_price',
            minWidth: 50,
            currentWidth: 60,
            isResizable: true,
            onRender: renderEditableCell
        },
        {
            key: 'calculated_total_price',
            name: 'Calc. Price',
            fieldName: 'calculated_total_price',
            minWidth: 50,
            currentWidth: 70,
            isResizable: true,
            onRender: renderEditableCell
        }
    ];

    if (includeCompoundQuantity && includeCompoundQuantity == true){
        cols.splice( 9, 0, {
            key: 'compound_quantity',
            name: 'Compound Qty',
            fieldName: 'compound_quantity',

            minWidth: 30,
            currentWidth: 50,
            maxWidth: 60,
            isResizable: true,
            isPadded: false,
            onRender: renderEditableCell
        } );
    }

    if (recoDynamicCols && recoDynamicCols.length > 0 ){
        recoDynamicCols.forEach( ( colKey ) => {
            cols.splice( 5, 0, {
                key: colKey,
                name: colKey.split('.').slice(-1)[0].replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
                fieldName: colKey,
                minWidth: colKey.toLowerCase().indexOf('descr') > -1 ? 160 : 30,
                targetWidthProportion: 2,
                isResizable: true,
                onRender: renderDisabledNestedCell
            } );
        })
    }
    return cols;
};

export const invTotalRowColumns = (renderTotalsCell: ( item: any, index?: number, column?: IColumn ) => JSX.Element,) => {
    let cols: IColumn[] = [
        {
            key: 'celllabel',
            name: 'celllabel',
            fieldName: 'celllabel',
            minWidth: 20,
            maxWidth: 230,
            currentWidth: 20,
            isResizable: true,
            isPadded: false,

            onRender: renderTotalsCell
        },
        {
            key: 'total_price',
            name: 'Line Price',
            fieldName: 'total_price',
            minWidth: 90,
            isResizable: true,
            onRender: renderTotalsCell
        },
        {
            key: 'calculated_total_price',
            name: 'Calc. Price',
            fieldName: 'calculated_total_price',
            minWidth: 90,
            isResizable: true,
            isPadded: false,
            onRender: renderTotalsCell
        }
    ];


    return cols;
};

export const getInvTableTotalRow = ( invItemsData: any[], precalc_total: number ) =>
{
    import.meta.env.DEV && console.log("‹getInvTableTotalRow›", invItemsData, precalc_total);
    return [
        {
            labelcell: "",
            total_price: invItemsData.reduce( ( acc, item ) => acc + Number( item.total_price ), 0 ).toFixed( 2 ),
            calculated_total_price: precalc_total // invItemsData.reduce( ( acc, item ) => acc + Number( item.calculated_total_price ), 0 ).toFixed( 2 )
        }
    ]
}









// styles

export const invItemsTextFieldStyles: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist",
                fontSize: "10px"
            }
        }
    },
    prefix: {
        backgroundColor: "transparent"
    },
    root: {
        borderRadius: "5px",
        fontSize: "10px"
    },
    fieldGroup: {
        borderRadius: "5px",
        fontSize: "10px",
        border: "1px solid #E1E4E7",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #333"
            }
        }
    },
    field: {
        fontSize: "11px"
    },
    subComponentStyles: {
        label: {
            padding: "0px !important",
            margin: "0px !important",
            root: {
                padding: "0px !important",
                margin: "0px",
                fontSize: "12px",
                fontFamily: "Urbanist"
            }
        }
    }
};
export const invTotalsTextFieldStyles: Partial<ITextFieldStyles> = {
    wrapper: {
        padding: "0px !important",
        margin: "0px !important",
        top: "0px !important",
        height: "40px !important",
        selectors: {
            label: {
                fontFamily: "Raleway",
                fontSize: "15px"
            }
        }
    },
    prefix: {
        backgroundColor: "transparent"
    },
    root: {
        borderRadius: "5px",
        fontSize: "15px",
        height: "20px"
    },
    fieldGroup: {
        borderRadius: "5px",
        fontSize: "15px",
        backgroundColor: "transparent",
        border: "none"

    },
    field: {
        fontSize: "17px",
        fontFamily: "Urbanist, Roboto",
        fontWeight: "700",
        backgroundColor: "transparent",
        border: "none"
    },
    subComponentStyles: {
        label: {
            padding: "0px !important",
            margin: "0px !important",
            root: {
                padding: "0px !important",
                margin: "0px",
                fontSize: "15px",
                fontFamily: "Urbanist"
            }
        }
    }
};
export const invIconItemDeleteStyles: Partial<IButtonStyles> = {
    root: {
        color: "#333333",
        fontSize: "20px",
        transition: "transform 0.1s ease-in-out",
        selectors: {
            ":active": {
                transform: "scale(0.9)", // Makes the button smaller when pressed

                color: "#333"
            }
        }
    },
    iconPressed: {
        transform: "scale(0.9)" // Ensures the icon also scales when pressed
    }
};
export const invDetailListStyles: Partial<IDetailsListStyles> = {
    root: {
        margin: "0px !important",
        padding: "0px !important",
        paddingTop: "0px !important",

        width: "100%",
        maxWidth: "100%",
        fontSize: "12px",
        paddingBottom: "45px",
        position: "relative"
    },
    headerWrapper: {
        top: 0,
        width: "fit-content",
        zIndex: 100,
        backgroundColor: "#fff",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
    } as IStyle,

    contentWrapper: {
        padding: "0px !important",
        margin: "0px !important",
        minHeight: "30vh !important"
    }
};
export const invDetailsHeaderCustomStyles: Partial<IDetailsHeaderStyles> = {
    root: {
        width: "max-content",
        minWidth: "100%",
        padding: "0px !important",
        margin: "0px !important",

        font: "normal normal 13px/40px Urbanist,Roboto !important",
        fontFamily: "Urbanist, Roboto",
        cursor: "pointer",
        position: "sticky",
        top: 0,
        zIndex: 100,
        backgroundColor: "#fff",
        borderBottom: "1px solid #ddd",
        paddingBottom: "0px !important",

    },
    check: {
        padding: "0px !important",
        margin: "0px !important",
        fontFamily: "Urbanist, Roboto !important",
    },
    cellWrapperPadded: {
        padding: "0px 5px !important",
        margin: "0px !important",
        width: "100%",
    }

};
export const invRecoTableStyles: Partial<IDetailsRowStyles> = {
    root: {
        fontSize: "10px",
        minHeight: "30px !important",
        height: "30px !important",
        fontFamily: "Urbanist",
        backgroundColor: "#f1f1f1",
        selectors: {
            ":hover": {
                backgroundColor: "#f3f2f1"
            }
        },

        padding: "0px !important",
        margin: "0px !important",
        bottom: "0px !important"
    },
    cell: {
        margin: "0px",
        paddingTop:"0px !important",
        paddingBottom:"0px !important",
        paddingRight:"0px !important",
        paddingLeft:"0px !important",
        minHeight: "30px !important",
        height: "30px !important",
        fontSize: "12px",
        fontFamily: "Urbanist, Roboto",
        border: "none !important"

    },
    fields: {
        minHeight: "30px !important",
        height: "30px !important",
        padding: "0px !important",

        margin: "0px !important",
        fontSize: "10px",
        fontFamily: "Urbanist"
    }
};
export const invDetRowTotalsStyles: Partial<IDetailsRowStyles> = {
    root: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        alignContent: "flex-end",
        alignItems: "flex-end",
        textAlign: "right !important",
        flexWrap: "wrap",

        minHeight: "30px !important",
        height: "30px !important",
        fontFamily: "Urbanist",
        backgroundColor: "#f1f1f1",
        selectors: {
            ":hover": {
                backgroundColor: "#f3f2f1"
            }
        },
        padding: "0px !important",
        margin: "0px !important",
        bottom: "0px !important"
    },
    cell: {
        textAlign: "right !important",
        alignItems: "end",
        justifyContent: "flex-end",
        flexWrap: "wrap",
        position: "relative",
        right: "0px !important",
        marginTop: "-1px",
        paddingTop:"0px !important",
        paddingBottom:"0px !important",
        paddingRight:"0px !important",
        minHeight: "30px !important",
        height: "30px !important",
        fontSize: "26px !important",
        fontFamily: "Urbanist, Roboto",

    },
    fields: {
        position: "absolute",
        right: "0px !important",
        textAlign: "right !important",
        verticalAlign: "middle",
        display: "flex",
        alignItems: "center",

        minHeight: "30px !important",
        height: "30px !important",
        padding: "0px !important",
        margin: "0px !important",
        fontFamily: "Urbanist"
    }
};
export const invDetailListTotalStyles: Partial<IDetailsListStyles> = {
    root: {
        margin: "0px !important",
        padding: "0px !important",
        paddingTop: "0px !important"
    },
    headerWrapper: {
        margin: "0px !important",
        padding: "0px !important",
        position: "sticky",
        top: 0,
        zIndex: 100,
        backgroundColor: "transparent",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
    } as IStyle,
    contentWrapper: {
        width: "100vw",
        padding: "0px !important",
        margin: "0px !important"
    }
};
export const invItemsMainSaveButtonStyles: Partial<IButtonStyles> = {
    root: {
        borderRadius: "5px",
        padding: "0px 0px 0px 0px !important",
        transition: "transform 0.1s ease-in-out",
        selectors: {

            ":disabled": {
                backgroundColor: "#ffe20300",
                opacity: 0.5,

                transform: "none",
            },
            ":active": {
                backgroundColor: "#FCF8DD",
                borderRadius: "5px",
                color: "#fff",
                borderColor: "#A2AF9B",
                transform: "scale(0.98)",
                padding: "1.5px 0px 0px 0px !important",
            }
        }
    },
    rootHovered: {
        borderRadius: "5px",
        backgroundColor: "#f3f2eb",
        color: "#333",
        selectors: {
            ":hover": {
                borderRadius: "5px",
                backgroundColor: "#f3f2eb",
                color: "#fff",
                transform: "scale(1.05)",
                transition: "transform 0.1s ease-in-out",

            },
            ":active": {
                backgroundColor: "#FCF8DD",
                borderRadius: "5px",
                color: "#fff",
                borderColor: "#A2AF9B",
                transform: "scale(0.98)",
            },
            ":disabled": {
                backgroundColor: "#ffe203",
                color: "#ccc",
                cursor: "not-allowed",
                transform: "none",
            }

        }
    },
};
export const tooltipInHeaderStyles: Partial<ITooltipStyles> = {
    root: {
        zIndex: 910039999,
    },
    content: {
        padding: "-20px"
    }
};
export const tooltipInInvItemTableControlsStyles: Partial<ITooltipStyles> = {
    root: {
        zIndex: 990039999999999,
    },
    content: {
        padding: "-20px"
    }
};

export const allowedGeneric = /[0-9\-.,]/;